import mapJson from 'jsonpath-mapper';
import { Entry } from 'contensis-management-api';
import { RequestHandler } from 'express';

import { saveRecorded } from '~/app/mockingMiddleware';
import { MigrateRequest } from '~/services';

import EntriesMigrationService from '~/services/EntriesMigrationService';
import mapAppErrorToObject from '~/transformations/mapAppErrorToObject';

export const returnEntries: RequestHandler = async (req, res, next) => {
  try {
    const { id, payload }: { id?: string; payload?: MigrateRequest } =
      res.locals;

    // Add any id param to the get query
    if (id && payload)
      payload.query = { ...(payload.query || {}), includeIds: [id] };

    const results = await new EntriesMigrationService(
      payload as MigrateRequest,
      true
    ).GetEntries({
      withDependents: req.path.includes('/all'),
    });
    let mappedResults: Entry[] = [];

    // Remap results to include only requested fields in REST response
    if (payload?.query?.fields?.length) {
      // map results to include only fields
      const fieldMapping = payload.query.fields.map<[string, any]>((key) => [
        key,
        key,
      ]);
      fieldMapping.push([
        'sys',
        { contentTypeId: 'sys.contentTypeId', id: 'sys.id' },
      ]);

      mappedResults = results.map((entry) =>
        mapJson(entry, Object.fromEntries(fieldMapping))
      );
    }

    const response = {
      committed: false,
      totalCount: results.length,
      items: mappedResults || results,
    };

    res.send(response);

    saveRecorded(req, res, {
      operation: 'returnEntries',
      response,
    });

    res.locals.response = response;
  } catch (ex: any) {
    res.locals.response = { error: mapAppErrorToObject(ex) };
    res.setHeader('expose-raw-errors', 'true');
    res.status(500).send(res.locals.response);
  }
  next();
};

export const migrateEntries: RequestHandler = async (req, res, next) => {
  try {
    const {
      payload,
      preview,
      download,
    }: {
      payload?: MigrateRequest;
      preview?: boolean;
      download?: boolean;
    } = res.locals;

    const migrationService = new EntriesMigrationService(
      payload as MigrateRequest,
      preview !== false ? true : false,
      download
    );

    const results = await migrationService.SyncEntries();

    const response = { committed: !preview, ...results };

    res.send(response);

    saveRecorded(req, res, {
      operation: 'migrateEntries',
      response,
    });

    res.locals.response = response;
  } catch (ex: any) {
    res.locals.response = { error: mapAppErrorToObject(ex) };
    res.setHeader('expose-raw-errors', 'true');
    res.status(500).send(res.locals.response);
  }
  next();
};

export const deleteEntries =
  (recycle = false): RequestHandler =>
  async (req, res) => {
    try {
      const {
        preview,
        payload,
      }: { preview?: boolean; payload?: MigrateRequest } = res.locals;

      const migrationService = new EntriesMigrationService(
        payload as MigrateRequest,
        preview !== false ? true : false
      );

      const results = await migrationService.DeleteEntries(recycle);
      const response = { committed: !preview, ...results };

      res.send(response);

      saveRecorded(req, res, {
        operation: recycle ? 'deleteEntries' : 'recycleEntries',
        response,
      });
    } catch (ex: any) {
      res.setHeader('expose-raw-errors', 'true');
      res.status(500).send({ error: mapAppErrorToObject(ex) });
    }
  };
